import { render } from "./EnglishVersion.vue?vue&type=template&id=72603c98&scoped=true"
import script from "./EnglishVersion.vue?vue&type=script&lang=js"
export * from "./EnglishVersion.vue?vue&type=script&lang=js"

import "./EnglishVersion.vue?vue&type=style&index=0&id=72603c98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72603c98"]])

export default __exports__